import React, { useRef } from 'react';
import { Col } from 'reactstrap';

const ToggleContainer = ({ toggle:Component }) => {
    const toggleStyles = useRef({ className: 'text-14' });
    return (
        <Col lg="6" md="6" sm="12" xs="12" className="mb-2">
            <Component styles={toggleStyles.current} />
        </Col>
    );
};

export default ToggleContainer;
